import request from '@/config/axios'

/** O2O 门店 — /admin-api/o2o/store/* */
export const O2oStoreApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/store/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/store/get?id=' + id })
  },
  create: async (data: any) => {
    return await request.post({ url: '/o2o/store/create', data })
  },
  update: async (data: any) => {
    return await request.put({ url: '/o2o/store/update', data })
  },
  delete: async (id: number) => {
    return await request.delete({ url: '/o2o/store/delete?id=' + id })
  }
}

/** O2O 排班 — /admin-api/o2o/schedule/* */
export const O2oScheduleApi = {
  getList: async (params: any) => {
    return await request.get({ url: '/o2o/schedule/list', params })
  },
  batchSave: async (data: any) => {
    return await request.put({ url: '/o2o/schedule/batch', data })
  }
}
